import React from 'react';
import '../Estilos/Estilo.scss';
import { Paginacion, getCurrentPage } from '../util/paginacion';
import Spinner from "react-bootstrap/Spinner";


class TFG extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.id,
            tfg: props.tfg,
            currentPagetfg: 1,
            loadingtfg: true,
            tfgActuales: [],
            itemPerPage: props.item,
            vacia: false

        };
        if (this.state.tfg.length <= 0) {
            this.state.vacia = true;
        }
    }
    render() {
        const windowWidth = window.innerWidth;
        const isDesktop = windowWidth > 600;
        return (
            <div>
                <div>

                    {/*{this.state.vacia ? <h1>No hay TFGs que mostrar</h1> : ''}*/}
                    {this.setState({ tfgActuales: this.state.tfg.slice((this.state.currentPagetfg - 1) * this.state.itemPerPage, this.state.currentPagetfg * this.state.itemPerPage), loadingtfg: false })}

                    {this.state.loadingtfg & !this.state.vacia ? <Spinner /> :
                        this.state.tfgActuales.map((
                            { title, author, director, tutor, grade, date, subjects,
                                college, department, registerID }) => {
                            return (
                                <div class='tfg-card' on >

                                    <div class="description">

                                        <h1><b>{title}</b></h1>
                                        <table>
                                            <tr>
                                                <b>Author:</b>{author}</tr>
                                            <tr>
                                                <b>Supervisor:</b>{tutor}</tr>
                                            {director.length <= 0 ? '' :
                                                <tr>
                                                    <b>Director:</b>{director}</tr>
                                            }
                                            <tr>
                                                <b>Degree name:</b>{grade}</tr>
                                            {this.state.id === 'tfgFinished' ?
                                                <tr>
                                                    <b>Viva:</b>{date}</tr>
                                                : ''}
                                            {subjects.length <= 0 ? '' :
                                                <tr>
                                                    <b>Topics:</b>{subjects.map((materia, currentValue) => { return (<text>{materia} {currentValue < subjects.length - 1 ? ',' : ''}</text>) })}
                                                </tr>
                                            }
                                            <tr>
                                                <b>School/Faculty:</b>{college}</tr>
                                            <tr>
                                                <b>Department:</b>{department}</tr>
                                            {this.state.id === 'tfgFinished' ?
                                                <tr>
                                                    <b>Registry ID:</b><a href={'https://oa.upm.es/' + registerID}>{registerID}</a></tr>
                                                : ''}

                                        </table>


                                    </div>
                                    {isDesktop ?
                                        <div class="imagenes">
                                            <a href={'https://oa.upm.es/' + registerID}><img src="assets\img\logos\archivoDigitalUPM-logo.png" height="130px" width="180px" alt='Imagen del proyecto' /></a>
                                        </div> : null}
                                </div>
                            );

                        })}
                </div>
                <Paginacion id={this.state.id} itemPerPage={this.state.itemPerPage} length={this.state.tfg.length} />
                {this.setState({ currentPagetfg: getCurrentPage(this.state.id) })}
            </div>
        );

    }
}
export default TFG;
